define.alias("shared/components/shared/mavely/links/search", "calendar/components/shared/mavely/links/search");